import RadarVisual from "./RadarVisual";

export default function Sensing() {
  return (
    <section
      id="sensing"
      data-testid="sensing-section"
      className="relative py-24 md:py-36 border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                In Context / Sensing
              </span>
              <span className="w-20 h-px bg-white/10" />
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-[44px] tracking-tighter font-medium text-white leading-[1.05]">
              Signals across sea and sky.
            </h2>
            <p className="mt-6 max-w-md text-[15px] md:text-base text-zinc-400 font-light leading-relaxed">
              Remote sensing — from coastal HF radar observing surface currents
              to broader electromagnetic and acoustic systems — is one of many
              contexts where our computational foundations apply. We study how
              information propagates, degrades, and can be recovered from the
              environment.
            </p>

            <ul className="mt-10 space-y-5 border-t border-white/10 pt-8">
              {[
                {
                  k: "Propagation",
                  v: "Modeling how signals travel through ocean, atmosphere, and clutter.",
                },
                {
                  k: "Estimation",
                  v: "Recovering state from noisy, indirect measurements.",
                },
                {
                  k: "Interpretation",
                  v: "Turning raw returns into decision-relevant information.",
                },
              ].map((row) => (
                <li
                  key={row.k}
                  className="flex items-start gap-6 border-b border-white/5 pb-5"
                >
                  <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 w-28 shrink-0 pt-0.5">
                    {row.k}
                  </span>
                  <span className="text-sm text-zinc-300 font-light leading-relaxed">
                    {row.v}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-7">
            <RadarVisual />
            <div className="mt-4 flex items-center justify-between font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
              <span>Fig. 01 — Coastal HF-radar schematic (illustrative)</span>
              <span>ν · t · r</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
